import React from "react";
import { RegionLink } from "./Types";
import { Icon, useIsMobile } from "@amzn/storm-ui";
import { spinner } from "@amzn/storm-ui-icons";
import { useBundle } from "@amzn/react-arb-tools";
import {
  RegionSelectorMetricsPublisher,
  InterstitialPageMetricsPublisher,
} from "../metrics";
import { useAccountContext } from "./AccountContextProvider";
import { RegionListDesktop } from "src/components/RegionListDesktop";
import { RegionListMobile } from "src/components/RegionListMobile";
import {ADSPGlobalBuyingStringTranslationSuffix} from "src/constants/ADSPGlobalBuyingConstants";

type RegionSectionProps = {
  regionLink: RegionLink;
};

export const RegionSection: React.VFC<RegionSectionProps> = ({
  regionLink,
}) => {
  const { numberOfAccountSelection } = useAccountContext();
  const isMobile = useIsMobile();
  const region = regionLink.region;
  const [bundle, isBundleLoading] = useBundle("pages.interstitial");

  if (!regionLink.url) {
    return null;
  }

  if (isBundleLoading) {
    return <Icon type={spinner}></Icon>;
  }

  const regionLabel = bundle.getMessage(
    regionLink.region + ADSPGlobalBuyingStringTranslationSuffix,
  );
  const handleClick = (url: string) => {
    RegionSelectorMetricsPublisher.publishCounterMonitor("select", 1);
    InterstitialPageMetricsPublisher.publishCounterMonitor(
      "account_selection",
      numberOfAccountSelection,
    );
      window.location.href = url;
  };

  return (
    <div key={region}>
      {isMobile && (
        <RegionListMobile handleClick={handleClick} regionLink={regionLink} regionLabel={regionLabel}/>)}
      {!isMobile && (<RegionListDesktop regionLink={regionLink} regionLabel={regionLabel} handleClick={handleClick}/>)}
    </div>
  );
};
